import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'mngFileSize',
  pure: true
})
export class MngFileSizePipe implements PipeTransform {
  transform(bytes: number, ...args: any[]): string {
    return formatFileSize(bytes) || '';
  }
}

/**
 * Formats a given `fileSizeInByte` to a human-readable string,
 * e.g., 15_144 -> '14.8 KB', 117_852_472 -> '112.39 MB'.
 * The file size is returned in Kibibytes (2¹⁰ - 1024 bytes) or Mebibytes (2²⁰ - 1024 kibibytes)
 * with the postfixes for Kilo- (1000 bytes) and Megabytes (1000 kilobytes) to be consistent with Windows.
 */
function formatFileSize(fileSizeInBytes: number): string {
  if (fileSizeInBytes === 0) {
    return '0 KB';
  }

  if (fileSizeInBytes > 1024 * 1024) {
    const mb = Math.round((fileSizeInBytes / (1024 * 1024)) * 100) / 100;
    return `${mb} MB`;
  } else {
    const kb = Math.round((fileSizeInBytes / 1024) * 10) / 10;
    return `${kb} KB`;
  }
}
